import { Loader } from 'kiswe-ui'
import { FanRoomScheduleConfigBase } from './FanRoomScheduleConfigBase'
import { FanRoomScheduleProcessState } from '../types'

export class FanRoomScheduleConfigTimed extends FanRoomScheduleConfigBase {
  enabled: boolean
  last_ended_at: Date|null
  last_error: string|null
  last_started_at: Date|null
  last_state: FanRoomScheduleProcessState
  run_at: Date

  constructor (data: unknown) {
    super(data)
    this.enabled = Loader.loadBoolean(data, 'enabled')
    this.last_ended_at = Loader.loadDateOrNull(data, 'last_ended_at', null)
    this.last_error = Loader.loadStringOrNull(data, 'last_error', null)
    this.last_started_at = Loader.loadDateOrNull(data, 'last_started_at', null)
    this.last_state = Loader.loadEnum(
      data, 'last_state', FanRoomScheduleProcessState.Pending, Object.values(FanRoomScheduleProcessState)
    )
    this.run_at = Loader.loadDate(data, 'run_at')
  }
}
